__turbopack_context__.v({
  "folderContainer": "FolderThumb-module__8gbakq__folderContainer",
  "folderContents": "FolderThumb-module__8gbakq__folderContents",
  "folderContentsCompact": "FolderThumb-module__8gbakq__folderContentsCompact",
  "folderSvg": "FolderThumb-module__8gbakq__folderSvg",
  "folderSvgCover": "FolderThumb-module__8gbakq__folderSvgCover",
});
